import { PaddingModel } from './padding.model';

export class DividerStyleDefaultsModel {
    height: number;
    dividerColor: string;
    backgroundColor: string;
    padding: PaddingModel;

    constructor(
        height: number,
        dividerColor: string,
        backgroundColor: string,
        padding: PaddingModel
    ) {
        this.height = height;
        this.dividerColor = dividerColor;
        this.backgroundColor = backgroundColor;
        this.padding = new PaddingModel();
        this.padding.paddingOption = true;
        this.padding.bottomPadding = 20;
        this.padding.topPadding = 20;
    }
}
